import './styles.scss';
import type { NetworkModeFormatterProps } from './networkModeFormatter.types';

/**
 * Signal strength indicator shown next to a device's network mode. Fills each of the four bars according to whether the RSSI exceeds 0, 25, 50 and 75, and prints the mode string beside them.
 *
 * @param rssi - Signal strength driving how many bars are filled.
 * @param networkMode - Network mode label shown next to the bars.
 * @returns The network mode element.
 */
const NetworkModeFormatter = ({ rssi = 0, networkMode = '' }: NetworkModeFormatterProps) => {
  const signalFillArr = [
    rssi > 0 ? 'fill' : '',
    rssi > 25 ? 'fill' : '',
    rssi > 50 ? 'fill' : '',
    rssi > 75 ? 'fill' : '',
  ];
  return (
    <div className="network-mode-formatter">
      <div className="signal-bar">
        <div className={`first-bar bar ${signalFillArr[0]}`} />
        <div className={`second-bar bar ${signalFillArr[1]}`} />
        <div className={`third-bar bar ${signalFillArr[2]}`} />
        <div className={`fourth-bar bar ${signalFillArr[3]}`} />
      </div>
      <span>{networkMode}</span>
    </div>
  );
};

export default NetworkModeFormatter;
